@if (this.currentCompanyStore.loaded()) {
  <dw-grid-list-page
    [title]="'Doc::Menu:SupplierPreparations' | abpLocalization"
    [activeView]="agGrid.activeView"
    [showCreationBtn]="false"
    [enableCreationBtn]="false"
    (deleteAction)="deleteEntities()"
    [enableExportBtn]="enableExport"
    [enableDeleteBtn]="enableDelete"
    (exportAction)="agGrid.export()"
    [enableDuplicateBtn]="false"
    [showDuplicateBtn]="false"
    [hasQuickSearch]="true"
  >
    <dw-grid-ag-grid
      [columnDefs]="colDefs"
      [datasource]="datasource"
      (rowClicked)="rowClicked($event)"
      [(selectedRows)]="selectedEntities"
      (selectedRowsClicked)="selectedRowsClicked($event)"
      #agGrid
      [context]="GoliathDocumentEntityNames.SupplierPreparation.shortName"
    >
    </dw-grid-ag-grid>
  </dw-grid-list-page>
}
